import React, { useState, useEffect } from 'react'
import { AlbumModel } from './Data'

export function Title(props: {
  album: AlbumModel,
  isLink?: boolean
}) {
  const artist = props.album.firstName + ' ' + props.album.lastName;
  const { title, releaseDate } = props.album;

  return <><b>{artist}</b> - <i>{title}</i> ({releaseDate})</>
}

export function Album(props: {
  album: AlbumModel,
  onClick: () => void
}) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    console.log(`Trying to fetch the image for ${props.album.title}`)
    const getCoverArt = async (releaseId: string) => {
      const response = await fetch(`https://coverartarchive.org/release/${releaseId}`)
      const json = await response.json()

      console.debug(`Got coverartarchive response for query for ${releaseId}`, json)

      let src; // TODO: create not found image

      for (const image of json.images) {
        if (image.thumbnails?.small) {
          src = image.thumbnails?.small
          break
        }

        if (image.image) {
          src = image.image
        }
      }

      if (!src) {
        throw new Error('No image found')
      }

      setImgSrc(src)
    }

    const getImg = async () => {
      const release = `release:${props.album.title}`
      const artist = `artist:${props.album.lastName}`

      let json;

      try {
        const response = await fetch(
          `https://musicbrainz.org/ws/2/release/?query=${release}%20AND%20${artist}&fmt=json`,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          })

        json = await response.json();
      } catch { // if that didn't work, try for a less aggressive search
        const response = await fetch(
          `https://musicbrainz.org/ws/2/release/?query=${release}&fmt=json`,
          {
            headers: {
              'Content-Type': 'application/json'
            }
          })

        json = await response.json();

      }

      console.debug(`Got musicbrainz response for query against ${props.album.title}`, json)
      
      for (const release of json.releases) {
        try {
          await getCoverArt(release.id)
        } catch {
          continue;
        }

        break;
      }
    }
    getImg()
  }, [props.album.lastName, props.album.title])

  return <figure className="album">
    <img 
      src={imgSrc} 
      alt={imgSrc ? props.album.title : ''}
    />
    <figcaption>
      <button onClick={props.onClick}>
        <Title album={props.album} />
      </button>
    </figcaption>
  </figure>
}